import React from 'react';
import useUser from '../../../hooks/useUser';
import AdvanceBillReportsCEO from './AdvanceBillReportsCEO';
import AdvanceBillReportsAdmin from './AdvanceBillReportsAdmin';
import AdvanceBillReportsManager from './AdvanceBillReportsManager';

const AdvanceReports = () => {
    const { userRole } = useUser();

    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    if (roleLower === 'ceo') {
        return <AdvanceBillReportsCEO />;
    }
    if (roleLower === 'admin') {
        return <AdvanceBillReportsAdmin />;
    }
    return <AdvanceBillReportsManager />;
};

export default AdvanceReports;
